import { Loader, Settings } from "lucide-react";
import { useState } from "react";
import { TimeoffPolicy } from "../../../../types";
import PolicyCard from "./policyCard";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../../redux/store";
import { setPolicyEditMode, setSelectedPolicyToEdit } from "../../../../redux/features/timeoffcategory";

interface PolicyListProps {
    categoryPolicies: TimeoffPolicy[];
    isLoadingPolicies: boolean;
}

const PolicyList: React.FC<PolicyListProps> = ({ categoryPolicies, isLoadingPolicies }) => {
    const [activeMenu, setActiveMenu] = useState<string | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleAddPolicy = () => {
        navigate("/create-time-off-rule");
    };

    const handleEditClicked = (policy: TimeoffPolicy) => { 
        dispatch(setSelectedPolicyToEdit(policy));
        dispatch(setPolicyEditMode(true));
        navigate("/create-time-off-rule");

    }

    return (
        <div className="flex-1 p-6 relative">
            <div className="flex justify-between items-center mb-6">
                {categoryPolicies.length > 0 && categoryPolicies[0] && (
                    <h2 className="text-2xl font-bold">{categoryPolicies[0].category_name}</h2>
                )}
                <button
                    className="flex items-center text-gray-700 border border-gray-300 py-2 px-4 rounded-lg hover:bg-gray-300"
                    onClick={handleAddPolicy}
                >
                    Add Policy
                </button>
            </div>
            {isLoadingPolicies ? (
                <div className="flex items-center justify-center h-full min-h-[300px]">
                    <Loader size={60} className="animate-spin text-gray-500" />
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 relative">
                    {categoryPolicies?.map((policy, index) => (
                        <PolicyCard
                            key={index}
                            title={policy.us_user_time_off_policy_name!}
                            activeMenu={activeMenu}
                            setActiveMenu={setActiveMenu}
                            policy={policy}
                            onEditClicked={handleEditClicked}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default PolicyList;
